export default __webpack_public_path__ + "static/media/java.84a5932c.svg";